import { enableMapSet } from 'immer';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface GlobalDataState {
  queryParams?: {
    queryUserId?: string;
  };
}

interface GlobalDataActions {
  updateGlobalQueryParams: (data: any) => void;
}

interface GlobalDataStore {
  state: GlobalDataState;
  actions: GlobalDataActions;
}

enableMapSet();

export const globalDataStore = create<GlobalDataStore>()(
  immer((set, get) => ({
    state: {
      queryParams: null,
    },
    actions: {
      updateGlobalQueryParams: (querys) => {
        const { queryParams } = get().state;

        set((store) => {
          store.state.queryParams = {
            ...queryParams,
            ...querys,
          };
        });
      },
    },
  }))
);
